import { ChangeEvent } from "react";
import Switch from "react-switch";
import Form from "react-bootstrap/Form";
import { DEFAULT_TOGGLE_ON_COLOR } from "@constants/colors";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import classNames from "classnames";
import styles from "./toggle-form-group.less";
import { IdwFormLabelWithIconContainer } from "../idw-form-label-with-icon-container/idw-form-label-with-icon-container";

type ToggleFormGroupProps = {
    controlId: string;
    labelWidth?: LabelWidthTypes;
    className?: string;
    automationId?: string;
    ariaLabel?: string;
    label: string;
    checked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    layout?: LayoutTypes;
    disabled: boolean;
    isRequired: boolean;
    value: string;
    afterInputLabel?: string;
    checkedIcon?: boolean;
    uncheckedIcon?: boolean;
    onColor?: string;
    offColor?: string;
    afterLabelTooltipText?: string;
};

export const ToggleFormGroup = (props: ToggleFormGroupProps) => {
    const {
        controlId,
        labelWidth,
        className,
        automationId,
        ariaLabel,
        label,
        checked,
        onChange,
        layout,
        disabled,
        isRequired,
        value,
        afterInputLabel,
        checkedIcon,
        uncheckedIcon,
        onColor,
        offColor,
        afterLabelTooltipText
    } = props;

    return (
        <Form.Group controlId={controlId} className={classNames(styles.toggleFormGroup, className ? className : "")}>
            {label && (
                <IdwFormLabelWithIconContainer
                    controlId={controlId}
                    labelWidth={labelWidth}
                    layout={layout}
                    label={label}
                    isRequired={isRequired}
                    afterLabelTooltipText={afterLabelTooltipText}
                />
            )}
            <div className={styles.toggleContainer}>
                <Form.Control
                    as={Switch}
                    required={isRequired}
                    automation-id={automationId}
                    aria-label={ariaLabel}
                    onChange={onChange}
                    checked={checked}
                    value={value}
                    disabled={disabled}
                    checkedIcon={checkedIcon}
                    uncheckedIcon={uncheckedIcon}
                    onColor={onColor || DEFAULT_TOGGLE_ON_COLOR}
                    offColor={offColor}
                />
            </div>
            {afterInputLabel && (
                <div className={styles.afterInputLabel}>
                    <span>{afterInputLabel}</span>
                </div>
            )}
        </Form.Group>
    );
};